/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Browser_Does_Not_Support_The_Video_TagInputs */

const en_your_browser_does_not_support_the_video_tag = /** @type {(inputs: Your_Browser_Does_Not_Support_The_Video_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your browser does not support the video tag.`)
};

const tr_your_browser_does_not_support_the_video_tag = /** @type {(inputs: Your_Browser_Does_Not_Support_The_Video_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarayıcınız video etiketini desteklemiyor.`)
};

/**
* | output |
* | --- |
* | "Your browser does not support the video tag." |
*
* @param {Your_Browser_Does_Not_Support_The_Video_TagInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const your_browser_does_not_support_the_video_tag = /** @type {((inputs?: Your_Browser_Does_Not_Support_The_Video_TagInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Browser_Does_Not_Support_The_Video_TagInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_browser_does_not_support_the_video_tag(inputs)
	return tr_your_browser_does_not_support_the_video_tag(inputs)
});